import { render, staticRenderFns } from "./ListCurrentYear.vue?vue&type=template&id=961153b6"
import script from "./ListCurrentYear.vue?vue&type=script&lang=js"
export * from "./ListCurrentYear.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports